import { RouteConfig } from '../interface'

const orderRoutes: RouteConfig[] = [
  {
    path: '/order',
    layout: () => import(/* webpackChunkName: "NowAppLayout" */ '@/pages/Order/layout') as any,
    children: [
      {
        path: '/order/report-restaurant',
        component: () =>
          import(
            /* webpackChunkName: "Report-ReportRestaurant" */ '@/pages/Order/views/ReportRestaurant/ReportRestaurant'
          ) as any,
      },
      {
        path: '/order/export-restaurant',
        component: () =>
          import(
            /* webpackChunkName: "Report-ExportRestaurant" */ '@/pages/Order/views/ExportRestaurant/ExportRestaurant'
          ) as any,
      },
      {
        path: '/order/report-dish',
        component: () =>
          import(
            /* webpackChunkName: "Report-ReportDish" */ '@/pages/Order/views/ReportDish/ReportDish'
          ) as any,
      },
    ],
  },
]

export default orderRoutes
